/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ApplicationPageFilter = {
    applyingStatus?: ApplicationPageFilter.applyingStatus;
    evaluationStatus?: ApplicationPageFilter.evaluationStatus;
    intentionStatus?: ApplicationPageFilter.intentionStatus;
    hasMemo?: boolean;
    paymentModel?: ApplicationPageFilter.paymentModel;
    productId?: number;
    templateId?: number;
    organizationId?: number;
    test?: boolean;
};

export namespace ApplicationPageFilter {

    export enum applyingStatus {
        IN_PROGRESS = 'IN_PROGRESS',
        CANCELLED = 'CANCELLED',
        COMPLETED = 'COMPLETED',
        INCOMPLETED = 'INCOMPLETED',
    }

    export enum evaluationStatus {
        NONE = 'NONE',
        WAITING = 'WAITING',
        IN_PROGRESS = 'IN_PROGRESS',
        PASSED = 'PASSED',
        FAILED = 'FAILED',
        RELIEVED = 'RELIEVED',
        RELIEVE_WAIT = 'RELIEVE_WAIT',
        DISQUALIFIED = 'DISQUALIFIED',
        RESIGNED = 'RESIGNED',
    }

    export enum intentionStatus {
        INITIALIZE = 'INITIALIZE',
        CONFIRMED = 'CONFIRMED',
        REVOKED = 'REVOKED',
        NON_RESPONSE = 'NON_RESPONSE',
    }

    export enum paymentModel {
        UPFRONT = 'UPFRONT',
        WEWIN = 'WEWIN',
        GOV_FUNDING = 'GOV_FUNDING',
        B2B = 'B2B',
        IMPACT_CAMPUS = 'IMPACT_CAMPUS',
        HYBRID = 'HYBRID',
        SCHOLARSHIP = 'SCHOLARSHIP',
    }


}

